module.exports = __webpack_public_path__ + "static/media/reblozyl-mds-logo.9e4dff51.png";